import { useCreateNoteMutation, useUpdateNoteMutation } from '@entities/clients/rtk-query.ts';
import { useLocation } from 'react-router-dom';
import { useClientNoteEditPageRedirect } from '@pages/clients/note/helpers.ts';

export const useNoteActions = () => {
  const location = useLocation();
  const { doRedirectOnPrevPage } = useClientNoteEditPageRedirect();

  const [createNoteMutation] = useCreateNoteMutation();
  const [updateNoteMutation] = useUpdateNoteMutation();

  const createNoteRecord = async (note: string) => {
    try {
      await createNoteMutation({ client: location.state.client.id, content: note });
      doRedirectOnPrevPage('/clients/clients');
    } catch (e) {
      console.error(e);
      throw new Error(`Create new note error: ${e}`);
    }
  };

  const updateNoteRecord = async (noteId: number, note: string) => {
    try {
      await updateNoteMutation({
        content: note,
        id: noteId,
      });
    } catch (e) {
      console.error(e);
      throw new Error(`Update note error: ${e}`);
    }
  };

  return {
    updateNoteRecord,
    createNoteRecord,
  };
};
